import * as React from "react";

function LazyBackground(props) {
    const { src, bgposition, bgrepeat, bgsize } = props;
    const [newSrc, setSrc] = React.useState(null);

    React.useEffect(() => {
        const img = new Image();
        img.src = src;
        img.onload = () => setSrc(src);
    }, [src]);

    return (
        <div
            {...props}
            style={{
                transition: ".1s",
                backgroundImage: `url(${newSrc || props.placeholder})`,
                backgroundPosition: bgposition,
                backgroundRepeat: bgrepeat,
                backgroundSize: bgsize,
            }}
        ></div>
    );
}
export default LazyBackground;
